import { render, staticRenderFns } from "./UserDetailDialog.vue?vue&type=template&id=4e6c7c85&scoped=true"
import script from "./UserDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailDialog.vue?vue&type=style&index=0&id=4e6c7c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c7c85",
  null
  
)

export default component.exports